export const setWebinarData = (webinarData) =>
	({
		type    : 'SET_WEBINAR_DATA',
		payload : { webinarData }
	});
export const setWebinarSocket = (webinarSocket) =>
	({
		type    : 'SET_WEBINAR_SOCKET',
		payload : { webinarSocket }
	});
export const setSelectedBrandingLogo = (selectedLogo) =>
	({
		type    : 'SET_SELECTED_WEBINAR_LOGO',
		payload : { selectedLogo }
	});

export const setSelectedBackground = (selectedBackground) =>
	({
		type    : 'SET_SELECTED_WEBINAR_BACKGROUND',
		payload : { selectedBackground }
	});
export const setOverlayData = (overlayImages) =>
	({
		type    : 'SET_WEBINAR_OVERLAY_IMAGES',
		payload : { overlayImages }
	});
export const setSelectedwebinarVideo = (webinarVideoClip) =>
	({
		type    : 'SET_SELECTED_WEBINAR_VIDEO',
		payload : { webinarVideoClip }
	});
export const setSelectedWebinarAudio = (webinarAudioClip) =>
	({
		type    : 'SET_SELECTED_WEBINAR_AUDIO',
		payload : { webinarAudioClip }
	});

export const setProductCode = (productCode) =>
	({
		type    : 'SET_PRODUCT_CODE',
		payload : { productCode }
	});
export const setSelectedWebinarOverlays = (webinarOverlays) =>
	({
		type    : 'SET_SELECTED_WEBINAR_OVERLAYS',
		payload : { webinarOverlays }
	});
export const setWebinarUserToVC = (moveToVc) =>
	({
		type    : 'SET_WEBINAR_USER_TO_VC',
		payload : { moveToVc }
	});
export const setSurveyDataStore = (surveyDataStore) =>
	({
		type    : 'SET_SURVEY_DATA',
		payload : { surveyDataStore }
	});